"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGtmContext = exports.trackGtmEvent = void 0;
const react_1 = require("react");
let CurrentContext = {};
function trackGtmEvent(event) {
    try {
        // @ts-ignore
        window.dataLayer.push(Object.assign(Object.assign({}, CurrentContext), event));
    }
    catch (e) {
        // Ignore everything. Don;t want to mess something up and have the user confused.
    }
}
exports.trackGtmEvent = trackGtmEvent;
function useGtmContext(context) {
    (0, react_1.useEffect)(() => {
        CurrentContext = Object.assign(Object.assign({}, CurrentContext), context);
        () => {
            for (let key in context) {
                delete CurrentContext[key];
            }
        };
    });
}
exports.useGtmContext = useGtmContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3RtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xpYi9ndG0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLGlDQUFrQztBQStJbEMsSUFBSSxjQUFjLEdBQTRCLEVBQUUsQ0FBQztBQUVqRCxTQUFnQixhQUFhLENBQUMsS0FBcUI7SUFDakQsSUFBSTtRQUNGLGFBQWE7UUFDYixNQUFNLENBQUMsU0FBUyxDQUFDLElBQUksaUNBQ2hCLGNBQWMsR0FDZCxLQUFLLEVBQ1IsQ0FBQztLQUNKO0lBQUMsT0FBTyxDQUFDLEVBQUU7UUFDVixpRkFBaUY7S0FDbEY7QUFDSCxDQUFDO0FBVkQsc0NBVUM7QUFFRCxTQUFnQixhQUFhLENBQUMsT0FBZ0M7SUFDNUQsSUFBQSxpQkFBUyxFQUFDLEdBQUcsRUFBRTtRQUNiLGNBQWMsbUNBQ1QsY0FBYyxHQUNkLE9BQU8sQ0FDWCxDQUFDO1FBQ0YsR0FBRyxFQUFFO1lBQ0gsS0FBSyxJQUFJLEdBQUcsSUFBSSxPQUFPLEVBQUU7Z0JBQ3ZCLE9BQU8sY0FBYyxDQUFDLEdBQUcsQ0FBQyxDQUFDO2FBQzVCO1FBQ0gsQ0FBQyxDQUFDO0lBQ0osQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDO0FBWkQsc0NBWUMifQ==